import dayjs from 'dayjs';

export const CONSTANT_0 = 0
export const CONSTANT_1 = 1
export const CONSTANT_2 = 2

export const carLicenseTypeList = [
    { value: CONSTANT_1, name: "代办上牌" },
    { value: CONSTANT_2, name: "客户自行" },
]
export const customerTypeList = [
    { value: CONSTANT_1, name: "个人" },
    { value: CONSTANT_2, name: "企业" },
]

export const clueTypeList = [
    { value: CONSTANT_1, name: "线上" },
    { value: CONSTANT_2, name: "线下" },
]

export const formatDate = (date) => {
    return {
        dateStart: date && date.length ? Math.round(dayjs(date[0]).valueOf() / 1000) : null,
        dateEnd: date && date.length ? Math.round(dayjs(date[1]).valueOf() / 1000) + 60 * 60 * 24 : null
    }
}